import React, { useMemo } from "react";
import { useTranslation } from "@opendash/core";
import { ParseSetView } from "@opendash/plugin-parse";
import { TableViewType } from "@opendash/plugin-parse/dist/types";
import { ColumnProps } from "antd/lib/table";

const Tagebuch = "CW_Tagebuch";

export default function KauflandMeta() {
  const t = useTranslation();

  return (
    <ParseSetView
      className={Tagebuch}
      view={
        {
          type: "table",

          fields: ["Start", "Ende", "Eintrag"],
        } as TableViewType
      }
    />
  );
}
